module.exports = __webpack_public_path__ + "img/matt_s_2.f00dcd67.png";